<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card class="text-center" no-shadow card-border>
          <h3 class="mt-base">{{ $t('messages.adding_new_business') }}</h3>
          <vs-alert color="warning" class="mt-base mb-3">
            {{ $t('messages.must_have_payping') }}
          </vs-alert>
          <a href="https://www.payping.ir/" target="_blank">{{ $t('messages.register_payping') }}</a>
          <p class="mt-base mb-3">
            {{ $t('messages.new_business_terms_read') }}
          </p>
          <a href="https://www.30teb.app/regulation" target="_blank">{{ $t('messages.terms_read') }}</a>

          <vs-row vs-justify="center" class="mt-base">
            <vs-button class="ml-3" color="success" :disabled="btnDisable" @click="createBusiness">{{
              $t('button.confirm')
            }}</vs-button>
            <vs-button class="ml-3" color="danger" type="border" to="/dashboard">{{
              $t('button.cancel')
            }}</vs-button>
          </vs-row>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data() {
    return {
      btnDisable: false
    }
  },
  methods: {
    createBusiness() {
      this.btnDisable = true
      axios
        .post('landing/business', {
          userId: this.$store.state.AppActiveUser.id,
          plan: 'free'
        })
        .then(() => {
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'))
          const roles = ['manager', 'nurse_center', ...userInfo.roles]
          this.$store.dispatch('updateUserInfo', { roles })
          this.$acl.change(roles)
          window.location = '/'
          this.$notifySuccess(this.$t('messages.your_business_added_successfully'))
        })
        .catch(error => {
          this.$notifyServerError(error)
        })
        .finally(() => {
          this.btnDisable = true
        })
    }
  },
  created() {
    if (this.$acl.check(['manager'])) {
      this.$notifyWarning(this.$t('messages.already_manager'))
      return this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>
